import React from "react";

import { MaintenanceDto } from "gql/generated/types";
import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import MaintenanceForm from "./MaintenanceForm";

type MaintenanceFormDialogProps = {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  maintenance?: MaintenanceDto;
};

const MaintenanceFormDialog: React.FC<MaintenanceFormDialogProps> = ({
  showDialog,
  setShowDialog,
  maintenance,
}) => {
  return (
    <Dialog
      header={T("mdm.maintenance")}
      visible={showDialog}
      onHide={() => setShowDialog(false)}
      style={{ width: "min(100vw, 1000px)", height: "400x" }}
      resizable
      modal
    >
      <MaintenanceForm closeDialog={() => setShowDialog(false)} maintenance={maintenance} newForm />
    </Dialog>
  );
};

export default MaintenanceFormDialog;
